/**
 * Generated by orval v7.16.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 換気
 */
export type TreatmentAirwayManagementVentilationEnum =
  (typeof TreatmentAirwayManagementVentilationEnum)[keyof typeof TreatmentAirwayManagementVentilationEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TreatmentAirwayManagementVentilationEnum = {
  MANUAL: 'MANUAL',
  EQUIPMENT: 'EQUIPMENT',
  OTHER: 'OTHER',
} as const;
